// =============================================
// COMPONENTE DE AÇÕES PARA RELATÓRIOS
// =============================================
// Arquivo: ReportActions.tsx
// Descrição: Componente para ações de exportação e impressão de relatórios
// =============================================

import React from 'react';
import './ReportActions.css';

// =============================================
// INTERFACES
// =============================================

interface ReportActionsProps {
  onExportPDF: () => void;
  onExportCSV: () => void;
  onPrint?: () => void;
  loading?: boolean;
  disabled?: boolean;
}

// =============================================
// COMPONENTE PRINCIPAL
// =============================================

/**
 * Componente ReportActions - Ações de exportação e impressão
 *
 * @param onExportPDF - Callback para exportar PDF
 * @param onExportCSV - Callback para exportar CSV
 * @param onPrint - Callback para imprimir (opcional)
 * @param loading - Estado de carregamento
 * @param disabled - Desabilitar ações
 * @returns JSX.Element - Componente de ações
 */
const ReportActions: React.FC<ReportActionsProps> = ({
  onExportPDF,
  onExportCSV,
  onPrint,
  loading = false,
  disabled = false
}) => {
  return (
    <div className="report-actions">
      <button
        className="action-btn action-btn-pdf"
        onClick={onExportPDF}
        disabled={loading || disabled}
        title="Exportar para PDF"
      >
        <i className="fas fa-file-pdf"></i>
        Exportar PDF
      </button>

      <button
        className="action-btn action-btn-csv"
        onClick={onExportCSV}
        disabled={loading || disabled}
        title="Exportar para CSV"
      >
        <i className="fas fa-file-csv"></i>
        Exportar CSV
      </button>

      {onPrint && (
        <button
          className="action-btn action-btn-print"
          onClick={onPrint}
          disabled={loading || disabled}
          title="Imprimir"
        >
          <i className="fas fa-print"></i>
          Imprimir
        </button>
      )}
    </div>
  );
};

export default ReportActions;
